var wordpressUrl = 'https://' + location.hostname + "/";
if (wordpressUrl == 'https://shop.thomasandthomas.com/') {
  wordpressUrl = 'https://www.thomasandthomas.com/';
}
// sticky navigation class

var Navigation = function () {
  this.offset = $('nav').offset().top,
    this.postsHaveReturned = true,
    this.toggleSticky = function () {

      if ($(window).scrollTop() > this.offset) {
        $('header, nav').addClass('sticky');
      } else {
        $('header, nav').removeClass('sticky');
      }

    },
    this.toggleMenu = function (parent) {
      if (parent.hasClass('show-mega-menu')) {
        parent.removeClass('show-mega-menu');
      } else {
        $('.show-mega-menu').removeClass('show-mega-menu');
        parent.addClass('show-mega-menu');
      }
    }
};

var navigation = new Navigation();


// Mapper Class

var Mapper = function () {
  this.geocoder = new google.maps.Geocoder(),
  this.map, // google map object
  this.markers = [], // markers array
  this.center = null,
  this.zoom = 10,
  this.minZoom = 3,
  this.locations = [],
  this.search = '', // search string
  this.location = 'north_america',
  this.ready = false, // true when getRawLocations returns successfully
  this.scrollwheel = false

  this.initialize = function () {
    var mapOptions = {
      center: this.center,
      zoom: this.zoom,
      minZoom: this.minZoom,
      scrollwheel: this.scrollwheel,
      mapTypeId: 'satellite'
    };

    // initialize map
    this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
    $('[name="continent"]').change();

  }, // end initialize

  this.setMapCenter = function () {
    var self = this;

    // use geocoder object to set map center

    this.geocoder.geocode({
      'address': this.search
    }, function (results, status) {

      if (status == google.maps.GeocoderStatus.OK) {
        self.center = results[0].geometry.location;

        // reinitialize map
        self.initialize();

        // set the zoom
        self.map.setZoom(self.zoom);
        self.placeMarkers();

      } else {
        console.log(status); // handle no results
      }
    });
  }, // end setMapCenter

  this.placeMarkers = function () {
    var self = this;

    // delete the current markers

    this.deleteMarkers();

    // filter location
    // show marker if is within mile radius from location

      var locations,
          place = autocomplete.getPlace();

      if (place){
        var select = document.getElementById('radius');
        var radius = parseInt( select.options[select.selectedIndex].value );
        
        var latLngA = place.geometry.location;

        locations = this.locations.filter(function (location) {
          var latLngB = new google.maps.LatLng(location.latitude, location.longitude);

          var dist = (google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB) / 1609.344).toFixed(2);

          if (dist <= radius){
            return location;
          } else {
            return false;
          }

        });
      } else {
        locations = this.locations;
      }
    
//     console.log(locations);
    
    locations.forEach(function (location) {

      // if we have latitude and longitude
      if (location.latitude && location.longitude) {

        var position = new google.maps.LatLng(location.latitude, location.longitude);

        // add marker to map
        self.addMarker(position, location);

      }

    });

  }, // end placeMarkers

  this.addMarker = function (position, location) {

    var self = this;

    // setup the marker object

    var content = '<div class="info-window">';

    content += '<strong>' + location.name + '</strong><br>';
    content += location.address + '<br>';
    content += 'Phone: ' + location.phone + '<br>';
    content += 'Email: ' + location.email + '<br>';
    content += '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: content,
      maxWidth: 300
    });

    var marker = new google.maps.Marker({
      position: position,
      map: this.map,
      title: location.name,
      address: location.address,
      email: location.email,
      name: location.name,
      phone: location.phone

    });

    // store the marker object in markers array

    this.markers.push(marker);

    // add a listener for each info window

    google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(this.map, marker);
    });
    
  }, // end addMarkers

  this.deleteMarkers = function () {

    // remove all markers

    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }

    // reset markers array

    this.markers = [];
  } // end deleteMarkers
};

// =================================== //
//          RESPONSIVE IMAGES          //
// =================================== //
class ResponsiveBackgroundImage {

    constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';

        this.img.addEventListener('load', () => {
            this.update();
        });

        if (this.img.complete) {
            this.update();
        }
    }

    update() {
        let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
        if (this.src !== src) {
            this.src = src;
            this.element.style.backgroundImage = 'url("' + this.src + '")';
        }
    }
}

// =================================== //
//            SIDEBAR RESIZE           //
// =================================== //
function updateSidebar() {
  var $width = document.documentElement.clientWidth,
      $height = document.documentElement.clientHeight,
      $main = $('.single .user-content').height(),
      $diff = $height - $main;

  if ($width > 768) {
    if ($main > $height) {
      $('.post-right-column').css({
        'min-height': $main
      });
    } else {
      $('.post-right-column').css({
        'min-height': $height
      });
    }
  } else {
    $('.post-right-column').removeAttr('style');
  }
}
$(window).load(function () { updateSidebar(); })
		 .resize(function () { updateSidebar(); });

var mapper;

$(function () { // document.ready
  
  // START RESPONSIVE BACKGROUND IMAGES
  let elements = document.getElementsByClassName('responsive-background-image');
  for (let i=0; i<elements.length; i++) {
    new ResponsiveBackgroundImage(elements[i]);
  }

  // START NAVIGATION JS
  navigation.toggleSticky();

  $(window).scroll(function () {
    navigation.toggleSticky();
  });

  // top level menu click to show mega menu functionality
  $('.main-navigation li span').click(function () {
    var parent = $(this).parent();
    var menu = parent.find('.mega-menu');

    if (menu.hasClass('and-our-blog')) {
      if (!$('body').hasClass('shopify-site') || navigation.postsHaveReturned) {
        navigation.toggleMenu(parent);
      }
    } else {
      navigation.toggleMenu(parent);
    }

  });

  // mobile menu

  $('.menu-icon').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    
    // accordian
    var $el = $('.right-menu'),
        curHeight = $el.height();
    $el.toggleClass('active');
    if ( curHeight == 0 ) {
      var newHeight = $el.css('height', 'auto').height();
    } else {
      var newHeight = 0;
    };
    
    $el.height(curHeight).height(newHeight);
  });

  // toggle mobile nav open

  $(document).on('click', 'li.has-sub > a', function (event) {

    if ($(this).attr("href") != "#") {
      window.location = $(this).attr("href");
      return true;
    } else {

      var parent = $(this).parent('li.has-sub');

      if (parent.hasClass('active')) {
        parent.removeClass('active');
      } else {
        parent.addClass('active');
      }
    }

  });

  $(document).on('click', '.sub-menu a', function (e) {
    window.location = $(this).attr("href");

  });

  $(window).resize(function () {

    if ($(window).width() > 1024) {
      $('.right-menu').removeClass('active');
    }
  });

  // mega menu toggle and hover functionality

  $(document).on('mouseenter', '.mega-left a', function (e) {

    if ($(this).data('id')) {
      var parent = $(this).parents('.mega-menu');

      parent.find('.mega-right .mega-detail').removeClass('active');

      $('.mega-detail[data-id="' + $(this).data('id') + '"]').addClass('active');
    }
  });

  $(document).on('mouseenter', '.mega-detail', function (e) {

    if ($(this).data('id')) {
      $('a[data-id="' + $(this).data('id') + '"]').addClass('active');
    }

  });

  $(document).on('mouseleave', '.mega-detail', function (e) {

    if ($(this).data('id')) {
      $('a[data-id="' + $(this).data('id') + '"]').removeClass('active');
    }

  });

  $(document).on('mouseenter', '.mega-product-menu a', function (e) {

    if ($(this).data('id')) {
      var parent = $(this).parents('.mega-detail');

      parent.find('.mega-product-image').removeClass('active');

      $('.mega-product-image[data-id="' + $(this).data('id') + '"]').addClass('active');
    }
  });

  $(document).on('mouseenter', '.mega-product-image', function (e) {

    if ($(this).data('id')) {
      console.log('here');
      $('a[data-id="' + $(this).data('id') + '"]').addClass('active');
    }

  });

  $(document).on('mouseleave', '.mega-product-image', function (e) {

    if ($(this).data('id')) {
      $('a[data-id="' + $(this).data('id') + '"]').removeClass('active');
    }

  });

  $('.and-rods .mega-left a:not(.click)').click(function (e) {
    e.preventDefault();
  });

  // dismiss menu when you click outside menu

  $('html').click(function () {
    $('.show-mega-menu').removeClass('show-mega-menu');
  });

  $('.main-navigation').click(function (e) {
    e.stopPropagation();
  });

  if ($('body').hasClass('shopify-site')) {

    $('.mega-product-images .mega-product-image:first-child').addClass('active');
    $('.and-apparel .mega-right .mega-detail:first-child').addClass('active');

    if ($(window).width() < 641) {
      $('.grid.product-single').append($('.grid__item.large--one-half:first-child'));
    }
  }

  // END NAVIGATION JS

  // START IMAGE GALLERY JS

  /*
		1. any <img> when clicked will show in the dialog
		2. <img class="no-dialog"> will be ignored
		3. any <img> inside <div class="image-group"> will be shown as a group
		*/

  var images = [];

  $('img').click(function () {


    if ($('body').hasClass('shopify-site') || $(this).hasClass('no-dialog') || $(window).width() < 641 || $(this).parent('#instafeed').length || $(this).parents('#map').length) { // if img has class no-dialog, do not show dialog
      return;
    }

    var source = $(this).attr('src'); // this is the src for the clicked image
    var photocredit = $(this).attr('alt');

    // var bgSource = document.getElementById('your_div_id'),
    // style = bgSource.currentStyle || window.getComputedStyle(img, false),
    // bi = style.backgroundImage.slice(4, -1);

    if ($(this).parents().hasClass('image-group')) { // image is part of a group

      $('.dialog-count').removeClass('dialog-hidden'); // show # of #

      $('.dialog-content img:not(.social-dialog)').attr('src', source); // source here is the clicked image

      $(this).parents('.image-group').find('img').each(function (index) { // for each of the images in the group
        // $(this) is now each image in the group

        if ($(this).attr('src') == source) { // if the clicked image src == the image source here, set the index
          $('.dialog-content img').data('index', index);
        }

        images.push($(this).attr('src')); // push all images into images array

      });


    } else { // image is not part of a group, just show the image in the dialog window

      $('.dialog-count').addClass('dialog-hidden'); // hide count because just one image

      $('.dialog-content img:not(.social-dialog)').attr("src", source); // set the img in the dialog to the clicked image source
      $('.dialog-content .photo-credit').text(photocredit);

    }

    updateButtonsAndCount();

    $('.dialog-for-images').addClass('dialog-open').removeClass('dialog-close'); // animate dialog box open
    $('.dialog-social').addClass('dialog-open').removeClass('dialog-hidden'); // hide count because just one image
  });

  $('.dialog-overlay').click(function () {
    $('.dialog-open').addClass('dialog-close').removeClass('dialog-open'); // animate dialog box close

    images = []; // reset images array
  });

  // show next image in the images array

  $('.dialog-next').click(function () {
    var index = $('.dialog-content img').data('index');

    $('.dialog-content img').attr('src', images[index + 1]).data('index', index + 1);

    updateButtonsAndCount();
  });

  // show previous image in the images array

  $('.dialog-previous').click(function () {
    var index = $('.dialog-content img').data('index');

    $('.dialog-content img').attr('src', images[index - 1]).data('index', index - 1);

    updateButtonsAndCount();
  });

  $('.dialog-x-close').click(function () {
    $(this).parents('.dialog').addClass('dialog-close').removeClass('dialog-open'); // animate dialog box close
  });


  // show / hide previous and next buttons, update the # of # count

  function updateButtonsAndCount() {
    $('.dialog-next, .dialog-previous').addClass('dialog-hidden');

    if (images.length > 0) {
      var index = $('.dialog-content img').data('index');

      if (index > 0) {
        $('.dialog-previous').removeClass('dialog-hidden');
      }

      if (index < images.length - 1) {
        $('.dialog-next').removeClass('dialog-hidden');
      }

      $('.dialog-count').html(index + 1 + ' of ' + images.length);
    }
  }

  // END IMAGE GALLERY JS

  // Facebook Share Dialogs
  // We bind a new event to our link
  $('a.fb').click(function (e) {
    //We tell our browser not to follow that link
    e.preventDefault();
    //We get the URL of the link
    var loc = $(this).attr('href');
    //We get the title of the link
    var title = encodeURIComponent($(this).attr('title'));
    //We trigger a new window with the Facebook dialog, in the middle of the page
    window.open('https://www.facebook.com/sharer/sharer.php?url=' + loc + '&text=' + title + '&', 'fbwindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 225) + ', left=' + $(window).width() / 2 + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

  });


  //Twitter Share Dialogs
  // We bind a new event to our link
  $('a.tweet').click(function (e) {
    //We tell our browser not to follow that link
    e.preventDefault();
    //We get the URL of the link
    var loc = $(this).attr('href');
    //We get the title of the link
    var title = encodeURIComponent($(this).attr('title'));
    //We trigger a new window with the Twitter dialog, in the middle of the page
    window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 225) + ', left=' + $(window).width() / 2 + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

  });



  // START FOOTER NEWSLETTER SUBMIT JS

  $('.footer-submit').click(function (e) {
    e.preventDefault();

    var email = $('[name="footeremail"]').val();
    if (email) {
      $('.footer-newsletter p').html('Processing...');

      $.ajax({
          method: 'POST',
          url: wordpressUrl + 'wp-content/themes/looklisten/inc/api/chimp.php',
          data: {
            email: $('[name="footeremail"]').val()
          }
        })
        .done(function (data) {

          if (data == 'success') {
            $('.footer-newsletter p').html('Thanks for signing up!');
          } else {
            $('.footer-newsletter p').html('There was an issue. Please try again.');
          }
        });
    } else {
      $('.footer-newsletter p').html('Please enter a valid email address.');
    }
  });

  // END FOOTER NEWSLETTER SUBMIT JS

  $('.newsletter-icon').click(function (e) {
    e.preventDefault();

    $('.dialog-newsletter').addClass('dialog-open').removeClass('dialog-close'); // animate dialog box open
  });

  $('.request-a-quote-button').click(function (e) {
    e.preventDefault();

    $('.dialog-request-quote').addClass('dialog-open').removeClass('dialog-close'); // animate dialog box open
  });

  // START FORM AJAX

  $(".content-form").on("submit", function (e) {
    e.preventDefault();

    if ($(this).data('form') == 'newsletter') {

      if ($('.dialog-newsletter [name="email"]').val()) {

        if ($('.dialog-newsletter [name="newsletter"]').is(':checked')) {
          sendAjaxForNewsletter($('.dialog-newsletter [name="email"]').val());
        }

        $('.newsletter').html('');
      } else {
        $('.newsletter').html('Please fill out out required fields');
      }

      return;
    }

    if (!grecaptcha.getResponse()) {
      $('.validation').html('Please verify you are a person.');

      return;
    }

    if ($(this).data('form') == 'share') {

      var data = new FormData();

      data.append('file_upload', $('[name="file_upload"]')[0].files[0]);

      $(this).serializeArray().forEach(function (element) {
        data.append(element.name, element.value);
      });

      if ($('[name="name"]').val() && $('[name="email"]').val() && $('[name="details"]').val()) {

        if ($('[name="newsletter"]').is(':checked')) {
          sendAjaxForNewsletter($('[name="email"]').val());
        }

        $.ajax({
            method: 'POST',
            url: wordpressUrl + 'wp-admin/admin-ajax.php',
            contentType: false,
            processData: false,
            data: data
          })
          .done(function (data) {
            $('.validation').html('Submission successful. Thank you.');
          });

        $('.validation').html('');
      } else {
        $('.validation').html('Please fill out required fields');
      }

    } else {

      if ($(this).data('form') == 'ask-pro') {

        if ($('[name="name"]').val() && $('[name="email"]').val() && $('[name="question"]').val()) {
          sendAjax($(this).serialize());
          $('.validation').html('Submission successful. Thank you.');
        } else {
          $('.validation').html('Please fill out out required fields');
        }
      }

      if ($(this).data('form') == 'product-registration') {

        if ($('[name="name"]').val() && $('[name="email"]').val()) {
          sendAjax($(this).serialize());
          $('.validation').html('Submission successful. Thank you.');
        } else {
          $('.validation').html('Please fill out out required fields');
        }
      }

      if ($(this).data('form') == 'repairs') {

        if ($('[name="name"]').val() && $('[name="email"]').val()) {
          sendAjax($(this).serialize());
          $('.validation').html('Submission successful. Thank you.');
        } else {
          $('.validation').html('Please fill out out required fields');
        }
      }

      if ($(this).data('form') == 'contact') {

        if ($('[name="name"]').val() && $('[name="email"]').val() && $('[name="reason"]').val() != 'Select') {

          if ($('[name="newsletter"]').is(':checked')) {
            sendAjaxForNewsletter($('[name="email"]').val());
          }

          sendAjax($(this).serialize());
          $('.validation').html('');
        } else {
          $('.validation').html('Please fill out out required fields');
        }
      }

      if ($(this).data('form') == 'request') {

        if ($('[name="name"]').val() && $('[name="email"]').val() && $('[name="content"]').val() && $('[name="phone"]').val()) {

          var product = '';

          if ($('body').is('#individualist')) {
            product = 'Individualist';
            tips = '2';
            console.log(tips);
          }

          if ($('body').is('#classic-bamboo')) {
            product = 'Classic Bamboo';
          }

          $.ajax({
              method: 'POST',
              url: wordpressUrl + 'wp-admin/admin-ajax.php',
              data: {
                rod: product,
                variant: $('.variant-sku').text(),
                name: $('[name="name"]').val(),
                email: $('[name="email"]').val(),
                content: $('[name="content"]').val(),
                phone: $('[name="phone"]').val(),
                option1: $('[data-option="option1"]').val(),
                option2: $('[data-option="option2"]').val(),
                option3: $('[data-option="option3"]').val(),
                action: 'submit_forms',
                form_name: 'request'
              }
            })
            .done(function (data) {
              $('.validation').html('Submission successful. Thank you.');
            });

          $('.validation').html('');
        } else {
          $('.validation').html('Please fill out required fields');
        }
      }
    }
  });

  function sendAjaxForNewsletter(email) {
    $.ajax({
        method: 'POST',
        url: wordpressUrl + 'wp-content/themes/looklisten/inc/api/chimp.php',
        data: {
          email: email
        }
      })
      .done(function (data) {
        $('.newsletter').html("You've signed up for our newsletter.");
      });
  }

  function sendAjax(form) {
    $.ajax({
        method: 'POST',
        url: wordpressUrl + 'wp-admin/admin-ajax.php',
        data: form
      })
      .done(function (data) {
        $('.validation').html('Submission successful. Thank you.');
      });
  }

  // END FORM AJAX


  // START STORE LOCATOR MAP

  if ($('body').hasClass('store-locations') || $('body').hasClass('store-locations-new') || $('body').hasClass('fly-fishing-store-locations') ) {
    mapper = new Mapper();
    mapper.locations = storeLocations;
    mapper.initialize();
    mapper.search = 'Bladen, NE';
    mapper.zoom = 3;
    mapper.setMapCenter();
    
//     console.log(mapper);
    
    $('[name="continent"]').change(function () {
      updateView($(this).val());
    });
    
    $('#radius').change(function () {
      if (autocomplete.getPlace()){
      	positionMap();
      }
    });
  }

  function updateView(continent) {
    $('[data-online="1"] .online-retailer').show();
    $('[data-lodge="1"] .lodge').show();
    if (continent == 'north_america') {
      mapper.search = 'Bladen, NE';
      mapper.zoom = 3;
      mapper.location = 'north_america';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="north_america"]').addClass('active');
    }
    if (continent == 'south_america') {
      mapper.search = 'Puerto SuÃ¡rez, Bolivia';
      mapper.zoom = 2;
      mapper.location = 'south_america';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="south_america"]').addClass('active');
    }
    if (continent == 'europe') {
      mapper.search = 'london, england';
      mapper.zoom = 3;
      mapper.location = 'europe';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="europe"]').addClass('active');
    }
    if (continent == 'asia') {
      mapper.search = 'shanghai, china';
      mapper.zoom = 3;
      mapper.location = 'asia';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="asia"]').addClass('active');
    }
    if (continent == 'africa') {
      mapper.search = 'bangui, central african republic';
      mapper.zoom = 2;
      mapper.location = 'africa';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="africa"]').addClass('active');
    }
    if (continent == 'australia') {
      mapper.search = 'sydney, australia';
      mapper.zoom = 3;
      mapper.location = 'australia';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-continent*="australia"]').addClass('active');
    }
    if (continent == 'online') {
      mapper.location = '';
      mapper.deleteMarkers();
      mapper.setMapCenter();
      $('.location-list li').removeClass('active');
      $('[data-online="1"]').addClass('active');
      $('[data-online="1"] .online-retailer').hide();
    }
    if (continent == 'lodge') {
      $('.location-list li').removeClass('active');
      $('[data-lodge="1"]').addClass('active');
      $('[data-lodge="1"] .lodge').hide();
    }
  }

  $('.footer-menu a[href="#"]').on('click', function (e) {
    e.preventDefault();
  });

});